import groq from 'groq';

export const GetLandingPageQuery = groq`*[_type == "landingPage"]{
  ...,
  "secondaryLinks" : secondaryLinks[] {
    _type == 'reference' => @->{
      "url": link.url,
      "text": link.text
    },
  },
  "primaryLinks" : primaryLinks[] {
    _type == 'reference' => @->{
      "url": link.url,
      "text": link.text
    },
  }
}[0]`;
